export default {
  methods: {
    generateCategoriesDataAgrupation () {
      const data = this.getCategoriesFromDashboardData()
      let dataset = [...data]
      this.expenseDashboardData.forEach(el => {
        dataset.forEach(defaultCategoryOfficeInDataSet => {
          const isDefaultCategoryInCurrentDateCategoryList = el.defaultCategoryOffices.find(
            el => el.defaultCategoryOfficeId === defaultCategoryOfficeInDataSet.id
          )
          if (isDefaultCategoryInCurrentDateCategoryList) {
            defaultCategoryOfficeInDataSet.data.push(
              Number.parseFloat(
                (
                  Math.round(
                    isDefaultCategoryInCurrentDateCategoryList.totalAmount * 100
                  ) / 100
                ).toFixed(2)
              )
            )
            defaultCategoryOfficeInDataSet.dates.push(el.dateSum)
          } else {
            defaultCategoryOfficeInDataSet.data.push(0)
            defaultCategoryOfficeInDataSet.dates.push(el.dateSum)
          }
        })
      })

      return dataset
    },
    getCategoriesFromDashboardData () {
      let dashboardCategories = []
      if (this.expenseDashboardData) {
        this.expenseDashboardData.forEach(dashboardItem => {
          if (dashboardItem && dashboardItem.defaultCategoryOffices) {
            dashboardItem.defaultCategoryOffices.forEach(defaultCategoryOffice => {
              if (defaultCategoryOffice.defaultCategoryOfficeId) {
                const isDefaultCategoryInDashboardCategories = dashboardCategories.find(
                  el => el.id === defaultCategoryOffice.defaultCategoryOfficeId
                )
                if (!isDefaultCategoryInDashboardCategories) {
                  const newDefaultCategoryData = {
                    id: defaultCategoryOffice.defaultCategoryOfficeId,
                    label: defaultCategoryOffice.defaultCategoryOfficeName,
                    startDate: dashboardItem.dateSum,
                    endDate:
                      this.filters.groupBy === 'month'
                        ? this.$moment.utc(dashboardItem.dateSum)
                          .endOf('month')
                          .format()
                        : this.$moment.utc(dashboardItem.dateSum)
                          .endOf('day')
                          .format(),
                    dataType: 'CATEGORY',
                    dates: [],
                    data: [],
                    backgroundColor: ''
                  }
                  newDefaultCategoryData.backgroundColor = this.getCategoryColor(
                    defaultCategoryOffice
                  )
                  dashboardCategories.push(newDefaultCategoryData)
                }
              } else {
                const isNotCategorizedData = dashboardCategories.find(
                  el => el.label === 'Sin categorizar'
                )
                if (!isNotCategorizedData) {
                  dashboardCategories.push({
                    id: null,
                    label: 'Sin categorizar',
                    startDate: dashboardItem.dateSum,
                    endDate:
                      this.filters.groupBy === 'month'
                        ? this.$moment.utc(dashboardItem.dateSum)
                          .endOf('month')
                          .format()
                        : this.$moment.utc(dashboardItem.dateSum)
                          .endOf('day')
                          .format(),
                    dataType: 'CATEGORY',
                    dates: [],
                    data: [],
                    backgroundColor: 'lightgray'
                  })
                }
              }
            })
          }
        })
      }

      return dashboardCategories.sort((a, b) => a?.id - b?.id)
    },
    getCategoryColor (category) {
      const categoryInfo = this.categories.find(
        el => el.id === category.defaultCategoryOfficeId)
      return categoryInfo?.color ?? '#e4e6e5'
    }
  },
  computed: {
    categories () {
      return this.$store.getters['CategoriesStore/categories']
    }
  }
}
